import React, {Suspense} from 'react';
import MileageAgreementDetail, {MileageAgreementDetailLoading} from '@di-shared/features/mileage/agreement/[termsId]';
import {useParams} from 'react-router-dom';
import {Navigate, useNavigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

interface MileageAgreementDetailProps {
  vin: string;
}

function MileageAgreementDetailPage({vin}: MileageAgreementDetailProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  const {termsId} = useParams();
  if (!termsId) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header
        right={
          <HeaderCloseButton onClick={() => navigate(ROUTE_PATHS.MILEAGE_AGREEMENT.getFullPath(vin) + location.search, {replace: true})} />
        }
      >
        <h1 className="headline_xxsmall nav_center_title">{t('T30199')}</h1>
      </Header>
      <Suspense fallback={<MileageAgreementDetailLoading />}>
        <MileageAgreementDetail
          vin={vin}
          termsId={termsId}
        />
      </Suspense>
    </div>
  );
}

export default MileageAgreementDetailPage;
